import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <a href="/">
          <img src="/logo512.png" alt="Book Matchup Logo" width="200" height="200" />
        </a>
      </div>
      <Link to="/forum/Feedback" className="footer-link">Feedback Forum</Link>
      <p className="footer-text">Please click link above to provide feedback.</p>
      <p>© {new Date().getFullYear()} Book Matchup. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
